<template>
    <v-app id="app" :class="isThemeAja ? 'theme-aja aja-bg-main' : ''">
        <link href="https://fonts.googleapis.com/css?family=Material+Icons" rel="stylesheet">
        <Snackbar />
        <router-view :key="$route.fullPath" />
    </v-app>
</template>

<style lang="sass">
@import "~@/styles/style.scss"
</style>

<script>
import { mapGetters, mapActions } from 'vuex'

const UNREAD_POLL_INTERVAL = 30000 // 30s

export default {
    name: 'app',
    data() {
        return {
            unreadPollTimer: null,
        }
    },
    computed: {
        ...mapGetters(['isThemeAja', 'isAuthenticated', 'getProfile']),
        shouldPollUnread() {
            const p = this.getProfile
            if (!p || p.role !== 'pro' || !p.mailbox_consent_at) return false
            const alias = p.mailbox_alias
            return !!(alias && alias.validated_at && !alias.is_blocked && !alias.deleted_at)
        },
    },
    watch: {
        shouldPollUnread(val) {
            val ? this.startUnreadPoll() : this.stopUnreadPoll()
        },
    },
    mounted () {
        this.checkAndSetTheme()
        if (this.shouldPollUnread) this.startUnreadPoll()
    },
    beforeDestroy() {
        this.stopUnreadPoll()
    },
    methods: {
        ...mapActions(['setThemeAja', 'fetchUnreadCount']),
        checkAndSetTheme() {
            this.setThemeAja(this.$store.getters.getProfile && this.$store.getters.getProfile.is_aja);
        },
        startUnreadPoll() {
            if (this.unreadPollTimer) return
            this.fetchUnreadCount()
            this.unreadPollTimer = setInterval(() => this.fetchUnreadCount(), UNREAD_POLL_INTERVAL)
        },
        stopUnreadPoll() {
            if (this.unreadPollTimer) {
                clearInterval(this.unreadPollTimer)
                this.unreadPollTimer = null
            }
        },
    }
}

</script>

<style>
.theme-aja {
    --v-primary-base: #4E983C;
}
</style>
